<!--  -->
<template>
  <div>
    <div class="layout">
      <div style="font-size:24px;color:red;margin-bottom:20px">扫码进行实名认证</div>
      <div class="qrcode">
        <div>
          <div id="qrcodeShare" ref="qrCodeUrl"></div>
          <Button @click="downLoad()" style="margin-top: 20px">下载二维码</Button>
          <div style="color:red;margin-top:20px">请下载二维码分享给贵司参会人员认证</div>
          <div style="color:red;margin-top:20px">本届展商认证手机号、邮箱信息已启动唯一性认证，同一手机号或邮箱重复认证只保留最后一个认证信息。</div>
        </div>
        <div class="tips">提示：可申请的数量=（展位面积/90）* 1
          <div style="color:red;font-size:20px;margin-top:20px;width:450px">当您展商证认证人数达到上限时，如需更新已认证人信息或替换人员信息，需将更新/替换人员先删除，再认证。</div>
        </div>
      </div>
      <Input search placeholder="请输入姓名" v-model="searchName" @on-search="searchAct" style="width: 230px; margin-top: 20px" />
      <div class="statistics">
        <div class="statistics-child">已认证人数:{{ okNumber }}</div>
      </div>
      <div class="custom-wrap">
        <template>
          <Table :border="false" :columns="columns1" :data="list" :disabled-hover="false">
            <template slot-scope="{ row }" slot="name">{{
              row.firstName
            }}</template>
            <template slot-scope="{ row }" slot="type">{{
              row.badgeType
            }}</template>
            <template slot-scope="{ row }" slot="state">{{
              row.authentication
            }}</template>
            <template slot-scope="{ row }" slot="action">
              <Poptip confirm title="确认是否删除?" @on-ok="delItem(row)" :transfer="true">
                <span style="color: #f00; cursor: pointer">删除</span>
              </Poptip>
            </template>
          </Table>
        </template>
        <div class="my-page" v-if="totalCount > pageSize" style="margin: 20px; text-align: center">
          <Page show-total show-elevator :page-size="pageSize" :current="pageIndex" :total="totalCount" @on-change="changePage" @on-page-size-change="changePageSize" />
        </div>
      </div>
    </div>
    <addCertExcel :addExcelShow="addExcelShow" @close="closeExcel" :init="init" :BadgeType="badgeType"></addCertExcel>
    <iModal title="添加参展名单" v-model="showModal" class-name="vertical-center-modal" width="600px" :mask-closable="false" @on-cancel="showModal = false">
      <div class="admin-add">
        <div class="admin-add-content">
          <Form ref="formInline" :model="formInline" :rules="ruleInline" label-position="right" :label-width="100">
            <FormItem label="姓名" prop="FirstName">
              <Input type="text" v-model="formInline.FirstName"></Input>
            </FormItem>
          </Form>
        </div>
      </div>
      <div slot="footer">
        <Button style="width: 90px" type="primary" :loading="loading2" @click="handleSubmit('formInline', 1)">完成</Button>
        <Button style="width: 90px" type="primary" @click="showModal = false">取消</Button>
      </div>
    </iModal>

    <iModal title="提示" v-model="Showsearch" class-name="vertical-center-modal" width="600px" :mask-closable="false" @on-cancel="Showsearch = false">
      <div class="admin-add">
        <div class="admin-add-content">
          查无此人
        </div>
      </div>
      <div slot="footer">
        <Button style="width: 90px" type="primary" @click="Showsearch = false">关闭</Button>
      </div>
    </iModal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import addCert from "./add-cert";
import QRCode from "qrcodejs2";
import addCertExcel from "./add-cret-excel";
export default {
  data() {
    return {
      columns1: [
        {
          title: "姓名",
          key: "firstName",
          align: "center",
          width: "300",
        },
        {
          title: "证件类型",
          key: "badgeType",
          align: "center",
        },
        {
          title: "状态",
          slot: "state",
          key: "authentication",
          align: "center",
        },

        {
          title: "操作",
          slot: "action",
          align: "center",
        },
      ],
      pageSize: 100000,
      pageIndex: 1,
      totalCount: 0,
      carShow: false,
      cardNumber: 0,
      card: 0,
      shareUrl: "", //二维码路径
      numberList: [],
      allNumber: 0,
      okNumber: 0,
      noNumber: 0,
      nullNumber: 0,
      addExcelShow: false,
      badgeType: "VIP",
      showModal: false,
      showerror: false,
      list: [],
      loading2: false,
      searchName: "",
      Showsearch: false,
      formInline: {
        FirstName: "",
      },
      ruleInline: {
        FirstName: [
          {
            required: true,
            message: "请输入姓名",
            trigger: "blur",
          },
        ],
      },
    };
  },
  components: {
    addCert,
    addCertExcel,
  },
  created() {
    this.init();
  },
  computed: {
    ...mapGetters({
      company: "loginModule/getCompany",
      exhibition: "loginModule/getExhibition",
      joinInfo: "loginModule/getJoinInfo",
    }),
  },
  methods: {
    ...mapActions({
      getqrcode: "exhibitionModule/qrcode",
      getAuthentication: "exhibitionModule/GetAuthentication",
      getList: "exhibitionModule/GetList",
      PostDeExCardPlan: "exhibitionModule/PostDeExCardPlan",
      DeletePlan: "exhibitionModule/DeletePlan",
    }),
    changePage(e) {
      this.pageIndex = e;
      this.getJoinList();
    },
    changePageSize(e) {
      this.pageSize = e;
      this.getJoinList();
    },
    searchAct() {
      this.getJoinList();
    },
    add() {
      if (this.joinInfo.boothArea < 9) {
        this.cardNumber = 3;
        if (this.totalCount > this.cardNumber) {
          this.showerror = true;
          return;
        } else {
          this.showModal = true;
        }
      } else if (this.joinInfo.boothArea > 9) {
        this.cardNumber = Math.round(this.joinInfo.boothArea / 9) * 3;
        if (this.totalCount > this.cardNumber) {
          this.showerror = true;
          return;
        } else {
          this.showModal = true;
        }
      }
    },
    closeModal() {
      this.carShow = false;
      this.$emit("closeModal");
    },
    closeExcel() {
      this.addExcelShow = false;
    },
    addExcel() {
      this.addExcelShow = true;
    },
    async init() {
      let string = "2021.25.pdf";
      let str1 = string.split(".");
      let index = str1.length;
      let str = str1[index - 1];
      let opt = {
        JoinId: this.joinInfo.joinId,
        BadgeType: "VIP",
        ExhibitionId: this.exhibition.id,
      };
      let data = await this.getqrcode(opt);
      if (data) {
        let curDate = `date=${new Date().getTime()}`;
        let url =
          data.shareUrl.indexOf("?") !== -1
            ? data.shareUrl + `&${curDate}`
            : data.shareUrl + `?${curDate}`;
        this.shareUrl = url;
        this.getQrCode();
      }
      //查询认证数量
      let body = await this.getAuthentication(opt);
      if (body.length) {
        this.numberList = body;
      }
      this.getJoinList();
    },
    async getJoinList() {
      let opt = {
        JoinId: this.joinInfo.joinId,
        FirstName: this.searchName,
        BadgeType: this.badgeType,
      };
      let data = await this.getList(opt);
      if (data.length) {
        data.forEach((e) => {
          e.authentication = "已认证";
        });
        this.list = data;
        this.totalCount = this.list.length;
        this.okNumber = this.list.length;
      } else {
        this.list = [];
      }
    },
    getQrCode() {
      this.$refs.qrCodeUrl.innerHTML = "";
      let qrcode = new QRCode("qrcodeShare", {
        width: 130,
        height: 130,
        text: this.shareUrl, // 二维码内容
        correctLevel: 3,
      });
    },
    downLoad() {
      let canvas = $("#qrcodeShare").find("canvas").get(0);
      this.downLoadImage(canvas);
    },
    downLoadImage(canvas) {
      var a = document.createElement("a");
      a.href = canvas.toDataURL();
      a.download = "二维码";
      a.click();
    },
    validForm(name) {
      return new Promise((resolve, reject) => {
        this.$refs[name].validate((valid) => {
          resolve(valid);
        });
      });
    },
    //单个添加参展名单
    async handleSubmit(name, e) {
      let valid = await this.validForm(name);
      if (!valid) return;
      let opt = {
        JoinId: this.joinInfo.joinId,
        BadgeType: "展商证",
        CompanyName: this.company.name,
        FirstName: this.formInline.FirstName,
      };
      let data = await this.PostDeExCardPlan(opt);
      if (data.successed) {
        this.$Message.success("添加成功");
        this.showModal = false;
      } else {
        this.$Message.error(data.msg);
      }
    },
    //删除名单
    async delItem(row) {
      let opt = {
        Id: row.id,
        PlanId: row.planId,
        JoinId: row.joinId,
        ExhibitionId: this.exhibition.id,
      };
      let data = await this.DeletePlan(opt);
      if (data.successed) {
        this.$Message.success("删除成功");
        this.getJoinList();
      } else {
        this.$Message.fail(data.msg);
      }
    },
  },
};
</script>
<style scoped lang='scss'>
.layout {
  min-width: 800px;
  margin: 30px;
  padding: 40px;
  min-height: 500px;
  background: #fff;
  padding-bottom: 190px;
  .header-tool {
    min-height: 90px;
  }
  &-content {
    min-width: 1000px;
    margin: 24px;
    padding: 40px;
    min-height: 500px;
    padding-bottom: 190px;
  }
  /deep/ {
    .ivu-tabs-tab {
      font-size: 24px;
      font-weight: bold;
    }
  }
}
.header-tool-box {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: end;
  -ms-flex-pack: end;
  justify-content: flex-end;
}
.htb-item {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  width: 150px;
  height: 80px;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  background-color: #fff;
  border: 2px dotted #b10042;
  color: #b10042;
  background: #ffe6e3;
  margin-left: 20px;
  cursor: pointer;
}
.qrcode {
  display: flex;
  align-items: center;
  #qrcodeShare {
    display: block;
    margin-right: 200px;
  }
  .tips {
    font-size: 24px;
  }
}
.statistics {
  margin: 30px 0;
  display: flex;

  &-child {
    margin-right: 10px;
  }
}
</style>